import type { InputHTMLAttributes } from 'react';

import styles from './Switch.module.css';

export type SwitchSize = 'default' | 'large' | 'small';
export type SwitchType = 'default' | 'text';

export interface SwitchProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'checked' | 'onChange' | 'size' | 'type'> {
  checked: boolean;
  /** 可访问名称；Figma 的可见文字由 checkedText / uncheckedText 提供。 */
  label: string;
  onCheckedChange: (checked: boolean) => void;
  size?: SwitchSize;
  type?: SwitchType;
  checkedText?: string;
  uncheckedText?: string;
}

export function Switch({ checked, checkedText, className, disabled, label, onCheckedChange, size = 'default', type = 'default', uncheckedText, ...inputProps }: SwitchProps) {
  const showText = type === 'text';

  return (
    <label className={[styles.root, className].filter(Boolean).join(' ')} data-disabled={disabled || undefined} data-size={size} data-type={type}>
      <input
        {...inputProps}
        aria-label={label}
        checked={checked}
        className={styles.control}
        disabled={disabled}
        onChange={(event) => onCheckedChange(event.target.checked)}
        type="checkbox"
      />
      {showText ? <span className={styles.sideText} data-active={!checked || undefined}>{uncheckedText}</span> : null}
      <span aria-hidden="true" className={styles.track}>
        <span className={styles.thumb} />
      </span>
      {showText ? <span className={styles.sideText} data-active={checked || undefined}>{checkedText}</span> : null}
    </label>
  );
}
